import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()
// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) =>
  cookies.set(sidebarStatusKey, sidebarStatus)

// User
const tokenKey = 'vue_typescript_admin_access_token'
export const getToken = () => cookies.get(tokenKey)
export const setToken = (token: string) => cookies.set(tokenKey, token)
export const removeToken = () => cookies.remove(tokenKey)
